module.exports = __webpack_public_path__ + "static/media/lancerings video kort.047e4a2f.gif";